import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Education from './components/Education';
import Skills from './components/Skills';
import Contacts from './components/Contacts';

function App() {
  return (
    <div className="App" id="body">
      <header id="header">
        <Navbar />
      </header>
      <main>
        <Home />
        <About />
        <Education />
        <Skills />
        <Contacts />
      </main>
    </div>
  );
}

export default App;
